<template>
  <b-card class="bg-white rounded-xl px-2">
    <AddBannerPopup :isOpen="isPopupOpen" @close="togglePopup" />
    <div class="flex justify-between items-center">
      <div>
        <h2 class="text-2xl font-semibold">List of Campaign Banner</h2>
      </div>
      <div class="flex items-center gap-4">
        <!-- <el-switch
          class="text-primary"
          v-model="isAvailableForUser"
          @change="updatepageVisible"
          active-text="Enable"
          inactive-text="Disable"
        >
        </el-switch> -->
        <base-button
          outline
          class="px-6 py-1 mx-1"
          type="primary"
          @click="handleAdd"
          :disabled="isAddDisabled"
          :class="{ 'cursor-not-allowed opacity-50': isAddDisabled }"
        >
          <span class="btn-inner--text flex justify-between items-center"
            ><feather-icon icon="PlusIcon" class="cust-HW"></feather-icon>Add
            Banner</span
          >
        </base-button>
      </div>
    </div>
    <BannerTable :data="aboutcampaignBanner.result" @delete="handleDelete" />
  </b-card>
</template>

<script>
import BannerTable from "./components/bannerTable.vue";
import AddBannerPopup from "../add-aboutcampaigns/components/AddBannerPopup.vue";
import { mapState } from "vuex";

export default {
  data() {
    return {
      isPopupOpen: false,
      isAvailableForUser: true,
      banners: [],
    };
  },
  components: {
    BannerTable,
    AddBannerPopup,
  },
  methods: {
    async updatepageVisible() {
      let payload = {
        _id: this.getMasterCampaign._id,
        campaignPageVisible: this.isAvailableForUser,
      };

      let data = await this.$store.dispatch(
        "campaignPageBanner/updateMaster",
        payload
      );

      if (data.code == 200) {
        this.$store.dispatch("campaignPageBanner/getMaster");
      }
    },
    handleAdd() {
      this.$router.push({ name: "addCampaign-banner" });
    },
    async handleDelete(data) {
      const result = await this.deleteAlert();
      if (result.isConfirmed) {
        this.$store.dispatch("campaignPageBanner/delete_campaignreference");
      }
    },

    async togglePopup(val = false) {
      this.isPopupOpen = val;
    },
  },
  mounted() {
    this.banners = this.aboutcampaignBanner.result || [];
    this.isAvailableForUser = this.getMasterCampaign.campaignPageVisible;
    console.log("aboutcampaignBanner", this.aboutcampaignBanner);
  },
  computed: {
    ...mapState("campaignPageBanner", ["getMasterCampaign"]),
    ...mapState("campaignPageBanner", {
      aboutcampaignBanner: "aboutcampaignBanner",
    }),
    isAddDisabled() {
      return this.aboutcampaignBanner.totalCount === 1;
    },
  },
};
</script>
<style>
.txt-color {
  color: #4f0a4b;
}
.cursor-not-allowed {
  cursor: not-allowed !important;
}
.opacity-50 {
  opacity: 0.5 !important;
}
</style>
